import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { ButtonContainer } from "./Action.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditTransport from "../../../AddEditTransport";
import "../../TransportList.scss";

const Action = (props) => {
  const { t, data, onRefreshData, updateRefeshStatus } = props;

  const [isAddTransportPopupVisible, setAddTransportPopupVisible] =
    useState(false);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const handleDisable = () => {
    setConfirmVisibility(true);
  };

  const editTrasnport = () => {
    setAddTransportPopupVisible(true);
  };
  const closeTransportCreationPopup = () => {
    setAddTransportPopupVisible(false);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };
  useEffect(() => {
    if (isConfirm) {
      const formStatus = data.isActive ? "0" : 1;
      if (data.isActive) {
        axios
          .delete(`/general/transports/${data.id}`)
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => {
            handleApiError(error);
            onRefreshData(true);
          });
      } else {
        axios
          .delete(`/general/transports/${data.id}`, {
            ...data,
            country: JSON.stringify(data.country),
            isActive: formStatus,
          })
          .then(() => {
            onRefreshData(true);
          })
          .catch((error) => {
            handleApiError(error);
            onRefreshData(true);
          });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <ButtonContainer>
      <div>
        <Image
          src={editIcon}
          onClick={editTrasnport}
          title={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          alt={t("GENERIC_ACTION_TOOLTIP_EDIT")}
          className="transport-list__edit-icon"
        />
        {!!data.isActive && (
          <Image
            src={deleteIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            title={t("GENERIC_ACTION_TOOLTIP_DISABLE")}
            className="transport-list__edit-icon"
          />
        )}
        {!data.isActive && (
          <Image
            src={activateIcon}
            onClick={handleDisable}
            alt={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            title={t("GENERIC_ACTION_TOOLTIP_ACTIVATE")}
            className="transport-list__edit-icon"
          />
        )}
      </div>

      {isAddTransportPopupVisible && (
        <AddEditTransport
          title={t("TRANSPORT_TYPE") + " #" + data.id}
          onClose={closeTransportCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          selectedTransport={data}
          isEditMode
          id={data.id}
        />
      )}

      {isConfirmVisible && (
        <WarningPopUp
          title={
            data.isActive == 0
              ? t("TRANSPORT_CONFIRMATION_BOX_ENABLE")
              : t("TRANSPORT_CONFIRMATION_BOX_DELETE")
          }
          message={
            data.isActive == 0
              ? t("TRANSPORT_CONFIRMATION_BOX_ENABLE_CONTENT")
              : t("TRANSPORT_CONFIRMATION_BOX_DELETE_CONTENT")
          }
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

Action.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(Action);
